import { Component, OnInit } from '@angular/core'
import { environment } from 'src/environments/environment'

import { CommonService } from '../shared/services/common.service'
import { WindowRef } from '../shared/services/window-ref.service'
import { Util } from '../utils/util'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  allLabelsForGlobalFooterNav: any
  termsAndConditionUrl: any
  privacyPolicyUrl: any
  baseURL: any

  constructor(
    private commonService: CommonService,
    private windowRef: WindowRef,
  ) {}

  ngOnInit(): void {
  this.commonService.getLabelsForGlobalMenus().subscribe((res)=>{
    this.allLabelsForGlobalFooterNav=res.menus['global-footer-navigation-menu']
  })
    let portNumber = window.location.port
    if (portNumber === '4200') {
      this.baseURL = environment.INTERNAL_LOCALBASEURL
    } else {
      this.baseURL = environment.BASEURL
    }
    this.privacyPolicyUrl = this.baseURL + '/privacy-policy'
    this.termsAndConditionUrl = this.baseURL + '/terms-and-conditions'
  }
  onFeedbackNavigate(): void {
    Util.feedbackEvent()
    this.windowRef.nativeWindow.KAMPYLE_ONSITE_SDK.showForm(
      environment.MEDALLIA_FID,
    )
    this.windowRef.nativeWindow.addEventListener(
      'MDigital_Submit_Feedback',
      function (mdEvent) {
        var mdDetail = mdEvent.detail
        var mdData = mdEvent.detail.Content
        console.log(mdDetail)
        console.log(mdData)
      },
      false,
      true,
    )
  }
}
